import { render } from "./Linksrapidos.vue?vue&type=template&id=4f2e1fac&scoped=true"
import script from "./Linksrapidos.vue?vue&type=script&lang=js"
export * from "./Linksrapidos.vue?vue&type=script&lang=js"

import "./Linksrapidos.vue?vue&type=style&index=0&id=4f2e1fac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2e1fac"]])

export default __exports__